import "./ViewAuthor.css";
import { useEffect, useState } from "react";
import { useParams, NavLink } from "react-router-dom";
import Skeleton from "../../components/Skeleton";
import { Helmet } from "react-helmet-async";

const ViewAuthor = ({ dark, MyBaseUrl }) => {
    const { name } = useParams();

  const [author, setAuthor] = useState(null);
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  const CACHE_KEY = `author_profile_${name}`;

  useEffect(() => {
  const fetchAuthorByName = async () => {
    try {
      setLoading(true);

      // 1. Fetch all authors
      const res = await fetch(`${MyBaseUrl}/authors`);
      const data = await res.json();

      const authorsList = data?.data?.data || [];

      // 2. Match slug
      const matchedAuthor = authorsList.find((a) => {
        const slug = a.name
          ?.trim()
          .toLowerCase()
          .replace(/[^a-z0-9\s]/g, "")
          .replace(/\s+/g, "-");

        return slug === name; // ⚠️ we will rename id → name below
      });

      if (!matchedAuthor) {
        setAuthor(null);
        setLoading(false);
        return;
      }

      // 3. Fetch author details using ID
      const res2 = await fetch(
        `${MyBaseUrl}/authors/${matchedAuthor.id}`
      );

      const data2 = await res2.json();

      const authorData = data2?.data?.author || null;
      const postsData = data2?.data?.posts?.data || [];

      setAuthor(authorData);
      setPosts(postsData);

    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  fetchAuthorByName();
}, [name]);

  return (
    <div className="homer">

      <Helmet>
  <title>
    {author?.name ? `${author.name} | Author Profile & Articles` : "Author Profile"}
  </title>

  <meta
    name="description"
    content={
      author?.bio
        ? `${author.name} - ${author.bio.slice(0, 150)}... Read articles and contributions by this sports writer.`
        : `View articles and profile of ${author?.name || "this author"} including their latest sports stories and analysis.`
    }
  />

  <meta
    name="keywords"
    content={`${
      author?.name || "author"
    }, sports writer, football journalist, articles by ${
      author?.name || "author"
    }, sports news contributor, football analysis, match reports`}
  />

  <meta
    property="og:title"
    content={`${author?.name || "Author"} | Sports Writer Profile`}
  />

  <meta
    property="og:description"
    content={
      author?.bio
        ? author.bio.slice(0, 160)
        : `Explore articles and contributions by ${
            author?.name || "this author"
          } in sports journalism.`
    }
  />
</Helmet>

      <div
        className="viewAuthor"
      >
        {loading ? (
          <Skeleton dark={dark} count={3} />
        ) : !author ? (
          <p style={{ textAlign: "center", marginTop: "40px" }}>
            Author not found
          </p>
        ) : (
          <>
            <div className="authorHero">
              <img
                className="heroBg"
                src={
                  author.avatar ||
                  "https://images.unsplash.com/photo-1508098682722-e99c643e7f0b"
                }
                alt=""
              />

            </div>
            
              <div className="heroContent" style={dark ? {backgroundColor: "#202020ff"} : {backgroundColor: "white"}}>

                <h1 style={dark ? {} : {color: "#161819"}}>{author.name}</h1>
                <h3 style={dark ? {} : {color: "#3e3f3f", borderBottom: "1px solid #ccc"}}>Chief Features Writer</h3>

                <div className="socials">
                  <span style={dark ? {} : { filter: "invert(1)"}}>𝕏</span>
                  <span style={dark ? {} : { backgroundColor: "#ebeae5ff", color: "#161819"}}>in</span>
                </div>

                <p className="bio" style={dark ? {} : {color: "#161819"}}>
                  {author.bio || "No bio available"}
                  {/* Lorem, ipsum dolor sit amet consectetur adipisicing elit. Vitae illum dicta repellat cupiditate ipsam eos, fuga labore minus molestias accusantium consequuntur nisi exercitationem repellendus totam non maxime eaque harum suscipit. */}
                </p>
              </div>

            <div className="articlesSection">
              <h1  style={dark ? { color: "#fff" } : {color: "#161819"}}>
                Articles by {author.name}
              </h1>

              {posts.length <= 0 ? (
                <p>No articles available</p>
              ) : (
                <div className="articlesList">
                  {posts.map((item, index) => (
                    <NavLink
                      to={`/news/${item.slug}`}
                      key={item.id || index}
                      className="articleCard" style={dark ? {backgroundColor: "#252525ff"} : {backgroundColor: "white"}}
                    >
                      <div className="text">
                        <h2 style={dark ? {} : {color: "#161819"}}>
                          
                        {item?.title?.length > 50
                          ? item?.title.slice(0, 50) + "..."
                          : item?.title}
                        </h2>
                        <span className="tag" style={dark ? {} : {color: "#3e3f3f"}}>
                          {item.type || "Article"}
                        </span>
                      </div>

                      <div className="imageWrap">
                        <img
                          src={
                            item.image ||
                            "https://images.unsplash.com/photo-1543326173-072045582f6f"
                          }
                        //   alt={item.title}
                        />

                        <div className="count">
                          💬 {item.views_count}
                        </div>
                      </div>
                    </NavLink>
                  ))}
                </div>
              )}
            </div>
          </>
        )}
      </div>

      
   
    </div>
  );
};

export default ViewAuthor;